import { createReducer, on } from "@ngrx/store";
import * as EAuthorizationActions from '../actions/eAuthorization.actions';
import { EAuthClientsResponse } from "../models/EAuthClients";

export const eauthKey = 'eauth';

export interface State {
    eauthClients: EAuthClientsResponse;
    hasServiceError: boolean;
    euthClientCallSuccess: boolean;
}

export const initialEAuthState: State = {
    eauthClients: {
        areAllAccountHoldersIneligible: false,
        isAccountRestricted: false,
        eauthClients: []
    },
    hasServiceError: false,
    euthClientCallSuccess: false
}

export const eAuthClientsReducer = createReducer(
    initialEAuthState,
    on(EAuthorizationActions.loadEAuthClientsSuccess, (_state, action) => {
        return {
            eauthClients: action.response,
            hasServiceError: false,
            euthClientCallSuccess: true
        }
    }),
    on(EAuthorizationActions.loadEAuthClientsFailure, (_state, action) => {
        return {
            eauthClients: {
                areAllAccountHoldersIneligible: true,
                isAccountRestricted: true,
                eauthClients: []
            },
            hasServiceError: true,
            euthClientCallSuccess: false
        }
    }),
    on(EAuthorizationActions.loadEAuthClients, (state, action) => {
        return {
            ...state,
            euthClientCallSuccess: false
        }
    })
);